import { render, staticRenderFns } from "./PaymentUpdater.vue?vue&type=template&id=4c0f3222&scoped=true&"
import script from "./PaymentUpdater.vue?vue&type=script&lang=js&"
export * from "./PaymentUpdater.vue?vue&type=script&lang=js&"
import style0 from "./PaymentUpdater.vue?vue&type=style&index=0&id=4c0f3222&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0f3222",
  null
  
)

export default component.exports